import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=f85addfa&scoped=true&"
import script from "./CompanyForm.vue?vue&type=script&lang=js&"
export * from "./CompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=f85addfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85addfa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/CompanyForm.vue
// module id = null
// module chunks = 